export const QUANTITIES = [20, 40, 60, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 320, 340, 360, 380, 400];
export const QUANTITY_OPTIONS = QUANTITIES.map(quantity => ({ label: quantity.toString(), value: quantity }));
export const DEFAULT_PAPER_TYPE_VALUE = 'smooth'; // use smooth as default to prevent bug with foil cards that dont have eggshell paper-type as an option
export const DEFAULT_SHAPE_VALUE = 'square';

export const BACK_PRINTING_PRICE = 35;
export const TEXT_ALIGNMENT_OPTIONS = ['LEFT', 'CENTER', 'RIGHT'];
export const ALL_FILTER_COLORS = [
  'BLACK',
  'BLUE',
  'BROWN',
  'GREEN',
  'GREY',
  'ORANGE',
  'PINK',
  'PURPLE',
  'RED',
  'WHITE',
  'YELLOW',
];

export const CUSTOMIZATION_BAR_DROPDOWN_SECTIONS = [
  {
    label: 'FRONT',
    description: 'Print on the front (required)',
    step: 'detailFront'
  },
  {
    label: 'BACK',
    description: 'Print on the back',
    step: 'detailBack'
  },
  {
    label: 'ENVELOPE',
    description: 'Print your return address',
    step: 'envelope'
  },
  {
    label: 'GUESTS',
    description: 'Add guest addressing',
    step: 'recipients'
  },
  {
    label: 'RSVP CARD',
    description: 'Add RSVP cards & envelopes',
    step: 'rsvp'
  },
  {
    label: 'RSVP ENVELOPE',
    description: 'Print mailing address',
    step: 'rsvpEnvelope'
  },
];

export const INVITES_PRODUCT_TYPES = ['INVITATION', 'RSVP', 'SAVE_THE_DATE', 'THANK_YOU'];

// these are the option values that must be present in the variation.option_values
// object of a customization for it to get updated by the customization bar
export const REQUIRED_OPTION_VALUE_KEYS = ['silhouette', 'paper-type'];


export const CARD_TYPE = {
  INVITATION: {
    type: 'INVITATION',
    urlSlug: 'invitations',
    label: 'Invitations',
    isLead: true
  },
  SAVE_THE_DATE: {
    type: 'SAVE_THE_DATE',
    urlSlug: 'save-the-date',
    label: 'Save The Dates',
    isLead: true
  },
  THANK_YOU: {
    type: 'THANK_YOU',
    urlSlug: 'thank-you-cards',
    label: 'Thank You Cards',
    isLead: true
  },
  MENU: {
    type: 'MENU',
    urlSlug: 'menus',
    label: 'Menus',
    isLead: true
  },
  PROGRAM: {
    type: 'PROGRAM',
    urlSlug: 'programs',
    label: 'Programs',
    isLead: true
  },
  DETAILS: {
    type: 'DETAILS',
    urlSlug: 'enclosures',
    label: 'Enclosures',
    isLead: true
  },
  RSVP: {
    type: 'RSVP',
    urlSlug: null, // secondary card type, no slug.
    label: 'RSVP',
    isLead: false
  },
  ENVELOPE: {
    type: 'ENVELOPE',
    urlSlug: null, // secondary card type, no slug.
    label: 'Envelope',
    isLead: false
  }
};



// WEBPACK FOOTER //
// ./src/cards/constants/Cards.js